

































































































































































import dateFormat from 'date-fns/format'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop, Watch } from 'vue-property-decorator'

import ToTopPage from '@/components/molecules/ToTopPage.vue'
import { Delivery, DeliveryContact } from '@/models/api/commerce-sales-order'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CartScopeEq } from '@/models/cart/group/scope'
import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { formatPrice } from '@/util/format'
import { User } from '@spa/store/modules/user/types'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CartItem } from '@spa/store/modules/cart/types'

import ContactViewItem from '../../organisms/contact/ViewItem.vue'
import CompletedSummary from '../../organisms/order/completed/Summary.vue'

import ContinueToOrder from './order-complete/ContinueToOrder.vue'
import OrderCvsNumberResult from './order/OrderCvsNumberResult.vue'
import OrderResultList from './order/OrderResultList.vue'

import { log } from '@/log'
import { PointFeatureIsEnabledService } from '@/services/api/point-feature'
import FreeAreaService from '@/services/free-area/free-area'
import MATag from '@/util/ma-tag'
import CALinkTag from '@/util/ma-tag/ca-link/index'
import { Order, OrderService } from '@spa/services/order'
import { isSinglePurchasable } from '@spa/store/modules/cart/function'
import { OrderResult, OrderResultSuccess } from '@spa/store/modules/orderConfirm/types'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

// ページ全体のローディング状態とは別に、個別のデータのローディング状態を管理する
interface PartialLoadingState {
  cart: boolean,
}

@Component({
  components: {
    ContactViewItem,
    CompletedSummary,
    OrderCvsNumberResult,
    OrderResultList,
    ToTopPage,
    ContinueToOrder,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class OrderComplete extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  freeAreaService: FreeAreaService

  @Prop({ required: true })
  orderService: OrderService

  @Prop({ required: true })
  behavior: BehaviorConfig

  @Prop({ required: true })
  readonly isReorder: boolean

  @Prop({ default: () => PointFeatureIsEnabledService.create() })
  pointIsEnabledService: PointFeatureIsEnabledService

  status: Status = Status.Pending
  partialLoadingState: PartialLoadingState = {
    cart: false,
  }

  topMessageFreeArea: string = ''

  maTag: MATag | null = null

  pointIsEnabled = false

  get user(): User {
    return this.$store.state.user.user
  }

  get orderResults(): OrderResult[] {
    return this.$store.state.orderConfirm.complete.orderResults
  }

  get successedOrders(): OrderResultSuccess[] {
    return this.orderResults.filter(r => r.success) as OrderResultSuccess[]
  }

  get paymentType(): PaymentType {
    // すべての注文に対して支払い方法は同一のものが設定されているのでどれを取得しても同じ
    return _.get(this.successedOrders, '[0].commerceSalesOrder.payment.method.kind', '')
  }

  get deliveries(): Delivery[] {
    return this.successedOrders.map(o => o.commerceSalesOrder.delivery)
  }

  /**
   * サマリーとして表示する配送情報
   * 現状ではすべての注文に関して同一のお届け先なので、配送日で代表を決定する。
   * ここでは配送日が一番早いものを代表として選択する。
   * 複雑になる場合、Delivery[] => Deliveryな関数を別途定義して利用するようにする。
   */
  get representiveDelivery(): Delivery | null {
    if (this.deliveries.length === 0) {
      return null
    }

    return _.minBy(this.deliveries, d => d.date) || this.deliveries[0]
  }

  get representiveDeliveryContact(): DeliveryContact | null {
    return _.get(this.representiveDelivery, 'contact', null)
  }

  get representiveDeliveryDate(): string | null {
    return _.get(this.representiveDelivery, 'date', null)
  }

  get formattedRepresentiveDeliveryDate(): string {
    return this.representiveDeliveryDate ? dateFormat(this.representiveDeliveryDate, 'YYYY年MM月DD日') : '指定なし'
  }

  get representiveDeliveryTimeSlotLabel(): string {
    return _.get(this.representiveDelivery, 'timeSlotLabel', '指定なし')
  }

  get totalPrice(): number {
    return _.sumBy(this.successedOrders, o => o.commerceSalesOrder.totalPrice)
  }

  get displayTotalPrice(): string {
    return this.formatPrice(this.totalPrice) || ''
  }

  get subtotalPrice(): number {
    return _.sumBy(this.successedOrders, o => o.commerceSalesOrder.subtotalPrice)
  }

  get displaySubtotalPrice(): string {
    return this.formatPrice(this.subtotalPrice) || ''
  }

  get commissions(): number[] {
    return this.successedOrders.map(o => o.commerceSalesOrder.commission).filter(c => c > 0)
  }

  get serviceFees(): number[] {
    return this.successedOrders.map(o => o.commerceSalesOrder.serviceFee).filter(f => f > 0)
  }

  get shipping(): number {
    return _.sum(this.shippings)
  }

  get shippings(): number[] {
    // TODO: calculate before this view
    return this.isFreeShipping ?
      [0] :
      this.successedOrders.map(o => o.commerceSalesOrder.shipping).filter(s => s > 0)
  }

  get couponDiscountPrice(): number {
    return _.sumBy(this.successedOrders, o => o.commerceSalesOrder.couponDiscountPrice)
  }

  get bundleDiscountPrice(): number {
    return _.sumBy(this.successedOrders, o => o.commerceSalesOrder.bundleDiscountPrice)
  }

  get pointDiscountPrice(): number {
    return _.sumBy(this.successedOrders, o => o.commerceSalesOrder.pointDiscountedPrice)
  }

  get estimatedPoints(): number {
    return _.sumBy(this.successedOrders, o => o.commerceSalesOrder.estimatedPoints)
  }

  get isFirstShareItem(): boolean {
    return this.$store.state.orderConfirm.complete.isFirstShareItem
  }

  get isFreeShipping(): boolean {
    return this.$store.state.orderConfirm.complete.isFreeShipping
  }

  get canScheduleDelivery(): number {
    return this.$store.state.orderConfirm.complete.canScheduleDelivery
  }

  get paymentIsCvsNumber(): boolean {
    return this.paymentType === 'cvs-number'
  }

  get isLoading(): boolean {
    return this.$store.state.view.isLoading
  }

  get useCarat(): boolean {
    return this.behavior.useCarat
  }

  get topMessage(): string {
    /**
     * - 再注文であれば再注文の文言
     * - それ以外は
     *   - フリーエリアが登録されていればフリーエリア
     *   - 登録されていなければデフォルトの文言
     *
     * 条件が複雑になるのであれば仕様オブジェクトなどに切り出すこと
     */
    if (this.isReorder) {
      return `注文内容の修正が完了しました。<br/>
        ご注文内容、配送状況はアカウントサービスよりご確認いただけます。`
    }
    if (this.topMessageFreeArea) {
      return this.topMessageFreeArea
    }

    return `ありがとうございます！<br/>
      ご注文が完了しました。お届けまで今しばらくお待ちください。<br/>
      ご注文内容、配送状況はアカウントサービスよりご確認いただけます。<br/>
      またのご利用をお待ちしております。`
  }

  /**
   * 複数注文に分かれた場合など、まだ同じスコープでまだカートに残っている商品
   * 購入できない商品は除外し、購入対象のものだけに絞り込む
   */
  get remainingOrders(): Order[] {
    const remainingCartItems = this.$store.getters['cart/displayItemsWithFilter'](isSinglePurchasable)

    return this.orderService.createOrderFromCartItems(remainingCartItems, '発送準備が整い次第')
  }

  get someOrdersRemaining(): boolean {
    return this.remainingOrders.length > 0
  }

  get isCartLoading(): boolean {
    return this.partialLoadingState.cart
  }

  formatPrice(price: number): string | undefined {
    return formatPrice(price)
  }

  formatSizeAndColor(item: CartItem) {
    return _.compact([item.size, item.color]).join('/')
  }

  beforeRouteEnter(_to, from, next) {
    const { path } = from

    if (
      path !== '/order' &&
      !path.startsWith('/order/complete/')
    ) {
      next({
        path: '/order',
        replace: true,
      })
    }

    next()
  }

  beforeRouteLeave(_to, _from, next) {
    this.$store.dispatch('orderConfirm/setComplete', null)

    next()
  }

  async destroyed(): Promise<void> {
    await this.$store.dispatch('view/stopLoading')
  }

  async navigateToOrderConfirm(): Promise<void> {
    await this.$store.dispatch('view/startLoading')

    /**
     * - beforeRouteLeaveでstoreのcompleteをリセットしているのでここでは実施しない
     * - ローディングの切れ目をなくすためにstopLoadingはdestroyedで実行
     * - 遷移先にscopeクエリを引き継ぐ必要があるが、router hookのqueriesToBeKeptで設定しているので不要
     */
    this.$router.push(`/order`)
  }

  initPointFeatureIsEnabled(): Promise<void> {
    return this.pointIsEnabledService.isEnabled().then((response) => {
      this.pointIsEnabled = response.on
    })
  }

  async created() {
    await this.$store.dispatch('view/startLoading')
    await Promise.all([
      this.loadFreeAreaContents(),
      this.initPointFeatureIsEnabled(),
      this.$store.dispatch('user/get'),
    ])
    // カートのロード完了を待たずにページを表示する
    // - カートのロードは時間がかかる
    // - ほとんどの場合はカートは空になっているはずで、カートが残っていたときの表示が必要なケースは少ない
    this.loadCartItems(this.scope),
    await this.$store.dispatch('view/stopLoading')

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  async loadCartItems(scope: CartScopeEq): Promise<void> {
    this.partialLoadingState.cart = true

    try {
      await this.$store.dispatch('cart/loadWithScope', {
        force: true,
        scope,
      })
    } catch (error) {
      // 完了画面表示時の主たる目的ではないので
      // 取得エラー時にはユーザーには何も提示せずカートが空だったときと同じ振る舞いをする
      log.error('loading cart failed', error)
    } finally {
      this.partialLoadingState.cart = false
    }
  }

  async loadFreeAreaContents(): Promise<void> {
    const [topMessageFreeArea] = await this.freeAreaService.fetch()
    if (topMessageFreeArea) {
      this.topMessageFreeArea = topMessageFreeArea.contentForMobile
    }
  }

  mounted() {
    EventBusForThirdParty.getInstance().publish('purchase', {
      orderResultSuccessList: this.successedOrders,
      user: this.user,
    })
  }

  @Watch('orderResults', { immediate: true })
  updateMATag(): void {
    if (!this.maTag) this.maTag = new CALinkTag()

    this.maTag.fkuIds = _.flatten(this.orderResults.map(result => (
      result.order.cartItems
        .filter(item => !item.isNovelty)
        .map(item => item.fkuId)
    )))

    this.maTag.setHtmlMetaElementTo(document)
  }
}
